import { render, staticRenderFns } from "./CorrectionUser.vue?vue&type=template&id=00f44434&"
import script from "./CorrectionUser.vue?vue&type=script&lang=js&"
export * from "./CorrectionUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports